import { Injectable } from '@angular/core';
import { WelcomeDTO } from "../../model/welcome.info";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { SiteApplicationDTO } from "../../model/siteApplication";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { WelcomeSumadiDTO } from '../../model/welcomeSumadi.dto';
// import { error } from 'console';
/*Servicio para consulta de la informacion de la pagina de bienvenida*/
@Injectable({
  providedIn: 'root'
})
export class WelcomeService {

  // DTO que contiene toda la informacionde bienvenida
  public data: WelcomeDTO;

  //DTO con la informacion de bienvenida del sitio
  public siteApplicationDTO: SiteApplicationDTO;

  /**Variable que almacena la imagen de fondo en Base64 */
  public waterMark: any;

  /** almacena el idCombo */
  public idCombo: any;

  private cacheStorage: any;

  public ltiInformation: WelcomeSumadiDTO;

  //constructor de la clase
  constructor(private http: HttpClient,
    private _configurationControlService: ConfigurationControlService) {
    this.data = null;
    this.http = http;
    this.waterMark = null;
    this.cacheStorage = null;
  }

  /*Se encarga de cambiar el nombre de un usuario en la base de datos
  principal del proyecto*/
  public changeUserName(token: string, credecial: number, newName: string, saberCode: string, userName: string): Promise<string> {
    let self = this;
    if (token) {
      let _headers = new HttpHeaders({
        'token': token,
        'credentialId': credecial.toString(),
        'newUserName': newName,
        'saberCode': saberCode,
        'user': userName
      });
      const options: {
        headers?: HttpHeaders,
        observe?: 'body',
        params?: HttpParams,
        reportProgress?: boolean,
        responseType: 'text',
        withCredentials?: boolean
      } = {
        headers: _headers,
        responseType: 'text'
      };
      return this.http.get(CONFIG.REST_END_POINT + 'changeUserName/',
        options)
        .toPromise();
    } else {
      console.log('error from service changeUserName no token');
    }
  }


  /*Se encarga de consultar la informacion del sitio donde se va
  a presentar el examen*/
  public queryApplicationSite(token: string,
    codeSaber: string,
    userName: string): Promise<SiteApplicationDTO> {
    let resp: any;
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'codeSaber': codeSaber,
      'user': userName
    });
    return this.http.get<SiteApplicationDTO>(CONFIG.REST_END_POINT + 'queryApplicationSite/',
      { headers: _headers })
      .toPromise();
  }


  public async loadServiceWorkerAll(urls: string[]): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      const loadServices = [];
      for (let i = 0; i < urls.length; i++) {
        loadServices.push(this.loadServiceWorkerSincrono(urls[i]));
      }
      Promise.all(loadServices)
        .catch(() => { resolve() })
        .then(() => { resolve() })
    });
  }

  public async loadServiceWorkerSincrono(url: string) {
    try {
      if (url.toLocaleLowerCase().endsWith(".png")
        || url.toLocaleLowerCase().endsWith(".jpg")
        //|| url.toLocaleLowerCase().endsWith(".mp3")
        //||url.toLocaleLowerCase().endsWith(".mp4")
      ) {
        if (this.cacheStorage == null) {
          this.cacheStorage = await caches.open(CONFIG.CACHE_NAME);
        }
        const urlImage = encodeURI(CONFIG.RUTA_BASE + url);
        const response = await this.fetchTimeout(urlImage, { mode: 'no-cors' }, CONFIG.TIME_OUT_CACHE);
        await this.cacheStorage.put(urlImage, response);

      }
    } catch (e) {
      console.log(`HTTP error! status: imagen ${url}`);
      console.error(e);
    }
  }

  async fetchTimeout(url: string, options: any, timeout: number) {
    const controller = new AbortController();
    const id = setTimeout(() => {
      controller.abort();
      console.log(`Timeout cache recurso :${url}`);
    }, timeout);
    const response = await fetch(url, {
      ...options,
      timeout: `${timeout}`,
      signal: controller.signal
    });
    clearTimeout(id);

    return response;
  }


  /** Se encarga de cargar los recursos en el caché del ServiceWorker */
  public loadServiceWorker(urls: any) {

    var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (is_chrome) {
      urls = JSON.parse(urls);
      navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
        return serviceWorkerRegistration.pushManager.getSubscription();
      }).then(function (subscription) {
        for (let i = 0; i < urls.length; i++) {
          if (!urls[i].endsWith("mp4")) {
            window.fetch(CONFIG.RUTA_BASE + urls[i], { mode: 'no-cors' }).then(function (response) {
              caches.open('precache-v4').then(function (cache) {
                cache.put(CONFIG.RUTA_BASE + urls[i], response).then(res => { }, err => { });
              });
            }).catch(function (error) {
              console.log(error);
            });
          }
        }

      })
    }
  }
}

